import { environment } from '../environments/environment';

/**
 * Prefix of current application.
 */
export const AppPrefix = 'MR';

/**
 * Path of static sources/
 */
export const AppHeading = {
  'ru-RU': '',
  'en-US': ''
};

export const AppPROD = environment.production;
export const AppApiURL = environment.apiUrl;
/** Static assets base URL. Always ends with / so that AppStaticURL + 'uploaded/images/...' yields a valid URL. */
export const AppStaticURL = environment.staticUrl.replace(/\/?$/, '/');
export const AppDomainURL = environment.domainUrl;
